"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var content_parser_1 = require("@dynamynd/content-parser");

var react_1 = __importStar(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var Paragraph_1 = require("../Paragraph/Paragraph");

var styled_1 = require("../styled");

var Title_1 = require("../Title/Title");

var CardTypeEnum;

(function (CardTypeEnum) {
  CardTypeEnum["default"] = "default";
  CardTypeEnum["locked"] = "locked";
})(CardTypeEnum || (CardTypeEnum = {}));

var Card =
/** @class */
function (_super) {
  __extends(Card, _super);

  function Card() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Card.prototype.render = function () {
    var _a = this.props,
        pressHandler = _a.pressHandler,
        title = _a.title,
        content = _a.content,
        renderActions = _a.renderActions,
        type = _a.type;
    return react_1.default.createElement(CardPressArea, {
      onPress: pressHandler
    }, react_1.default.createElement(CardContainer, {
      type: type
    }, react_1.default.createElement(CardTitle, null, react_1.default.createElement(content_parser_1.ParsedContent, {
      content: title
    })), react_1.default.createElement(CardBody, null, react_1.default.createElement(Paragraph_1.Paragraph, null, react_1.default.createElement(content_parser_1.ParsedContent, {
      content: content
    }))), react_1.default.createElement(CardAction, null, renderActions())));
  };

  Card.type = CardTypeEnum;
  return Card;
}(react_1.Component);

exports.Card = Card; // todo remove all box shadows for the mobile apps

var CardContainer = styled_components_1.default(function (_a) {
  var type = _a.type,
      rest = __rest(_a, ["type"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: 410px;\n    margin-bottom: 24px;\n    padding: 24px;\n    background: ", ";\n    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.14), -1px 2px 4px rgba(0, 0, 0, 0.14);\n    cursor: pointer;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: 410px;\n    margin-bottom: 24px;\n    padding: 24px;\n    background: ", ";\n    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.14), -1px 2px 4px rgba(0, 0, 0, 0.14);\n    cursor: pointer;\n"])), function (_a) {
  var type = _a.type;
  return type === CardTypeEnum.default ? 'white' : '#E9E9EA';
});
var CardPressArea = styled_components_1.default(react_native_1.TouchableWithoutFeedback)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-width: 100%;\n"], ["\n    min-width: 100%;\n"])));
var CardTitle = styled_components_1.default(Title_1.Title)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: 14px;\n    font-size: 18px;\n    line-height: 24px;\n"], ["\n    margin-bottom: 14px;\n    font-size: 18px;\n    line-height: 24px;\n"])));
var CardBody = styled_components_1.default(styled_1.Row)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: 24px;\n"], ["\n    margin-bottom: 24px;\n"])));
var CardAction = styled_components_1.default(styled_1.Row)(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;